import { Debugger, generateId } from "../utils";
import MeiAttribute from "./MeiAttribute";
import MeiJsonElem from "./MeiJsonXmlElement";


export type TMeiTagFactoryArgs = {
    tagTitle: MeiTag["tagTitle"],
    attributes?: { title: MeiAttribute["title"], value: MeiAttribute["value"] }[],
    children?: TMeiTagFactoryArgs[],
    selfClosing?: boolean
    textContent?: string
    id?: number
    xmlId?: string

}
export default abstract class MeiTag {

    setParent(p: MeiTag) {
        this.parent = p;
        return this;
    }
    set textContent(tc: string) {
        const someTextChild = this.children.find(ch => ch instanceof MeiText)
        if (someTextChild) someTextChild.setTextContent(tc)
            else  {
        const newChild = new MeiText(tc, Math.max(...this.children.map(ch => ch.indexAmongSiblings || 0))+1);
        this.pushChild(newChild)
        }
    }
    get textContent(): string {
        return this.children.filter(ch => ch instanceof MeiText).map(ch => ch.textContent).join('\n')
    }
    parent?: MeiTag;
    xmlId?: string;
    indexAmongSiblings?: number
    id?: number;
        selfClosing?: boolean
    children: MeiTag[] = []
    abstract tagTitle: string
    static instanceFromXmlElement(childNode: ChildNode, indexAmongSiblings = 0, parent?: MeiTag): MeiTag {
        if (childNode.nodeName == '#text' || !(childNode instanceof Element)) {

            const instance = new MeiText(childNode.nodeValue?.trim() || '', indexAmongSiblings)
            return instance
        } else {
            const el = childNode as Element
            if (el.tagName == 'title') {
                console.log(el.childNodes);
            }
            const instance = MeiTag.makeTagsTree({
                tagTitle: el.tagName,
                attributes: Array.from(el.attributes).map(at => ({ title: at.name, value: at.value })),
                children: Array.from(el.childNodes).filter(chNode => chNode.nodeType != childNode.TEXT_NODE || chNode.nodeValue?.trim()).map((ch, index) => MeiTag.instanceFromXmlElement(ch, index, parent)),
                selfClosing: el.children.length == 0 && !el.textContent,
                textContent: el.textContent?.trim()//el.children.length == 0 ? el.textContent?.trim() : undefined,
            }, parent)
            // console.log(instance.tagTitle + ': ', instance.children.map(ch =>ch.tagTitle).join(', '));

            instance.indexAmongSiblings = indexAmongSiblings;
            // instance.xmlId = el.getAttribute('xml:id')|| undefined
            instance.setXmlId(el.getAttribute('xml:id')!)
            return instance;
        }
    }
    setAllChildrenParent() {
        this.children.forEach(ch => {
            if (!ch.parent) ch.setParent(this)
            ch.setAllChildrenParent()
            // ch.children.forEach(grandChild => grandChild.setAllChildrenParent())
        })
    }

    sortChildren() {
        this.children = this.children.sort((a, b) => (a.indexAmongSiblings || 0) - (b.indexAmongSiblings || 0))
    }
    toJsonXmlElement(options = { keepEmptyNotes: false }): MeiJsonElem {
        this.updateChildren(options);
        this.setAttributes();

        return new MeiJsonElem({
            indexAmongSiblings: this.indexAmongSiblings,
            tagTitle: this.tagTitle,
            attributes: this.attributes,
            children: this.children.map(ch => ch.toJsonXmlElement(options)),
            textContent: this.textContent,
            selfClosing: this.selfClosing,
            id: this.id,
            xmlId: this.xmlId || this.getAttribute('xml:id')?.value
        })
    }

    setXmlId(xmlId?: string) {

        if (xmlId) {
            this.xmlId = xmlId;
            this.setAttribute(new MeiAttribute('xml:id', xmlId))
        }

    }
    attributes: MeiAttribute[] = [];
    // abstract setAttributes(): void;
    setAttributes(): void {
        if (this.xmlId) {
            this.setAttribute(new MeiAttribute('xml:id', this.xmlId))
        }
    }
    abstract updateChildren(options?: { keepEmptyNotes?: boolean }): MeiTag;

    setAttribute(att: MeiAttribute) {
        const alreadySameTitleAtt = this.attributes.find(a => a.title == att.title)
        if (alreadySameTitleAtt) alreadySameTitleAtt.value = att.value;
        else this.attributes.push(att)

    }

    removeAttribute(key: string) {
        const found = this.attributes.find(at => at.title == key)
        if (found) this.attributes.splice(this.attributes.indexOf(found), 1)

    }
    static makeTagsTree(args: TMeiTagFactoryArgs, parent?: MeiTag, Constructor?: new (args: any) => MeiTag) {

        const newTag = Constructor ? new Constructor(args) : new MeiTagInstance(args);
        newTag.selfClosing = args.selfClosing || false
        if (parent) newTag.setParent(parent)
        return newTag
    }
    addChildIfNotExists(child: MeiTag, index?: number): MeiTag {

        const found = this.children.find(ch => ch.tagTitle == child.tagTitle)
        if (!found) this.pushChild(child, index)
        return found ? found instanceof MeiTag ? found : new MeiTagInstance(found).setParent(this) : child //this.addChildIfNotExists(child, index)
    }

    hasTheSameAttributeAndValue({ title, value }: { title: string, value: string | undefined }) {
        if (value == undefined) return !!this.attributes.find(a => a.title == title)
        return !!this.attributes.find(a => a.title == title && a.value == value)
    }
    getChildrenByTagName(tagname: string) { return this.children.filter(ch => ch.tagTitle == tagname); }
    getGrandChildrenByTagName(tagname: string): MeiTagInstance[] {
        const directDesiredChildren = this.getChildrenByTagName(tagname)
        return [
            ...directDesiredChildren,
            ...this.children.map(ch => ch.getGrandChildrenByTagName(tagname)).reduce((sf, cr) => [...sf, ...cr], [])];
    }
    getAttribute(title: string) {
        return this.attributes.find(att => att.title == title)
    }
    getChildByTagName(tagname: string) {

        const testAtts = /(((?!\[).)*)\[((((?!=).)*)=(((?!\]).)*))\]/.exec(tagname);
        const attTofind = { title: <string>'', value: <string | undefined>'' }

        if (testAtts) {
            tagname = testAtts[1]
            attTofind.title = testAtts[4]
            attTofind.value = testAtts[6]
        } else {
            const testJustAttTitle = /(((?!\[).)*)\[((((?!\]).)*)\])/.exec(tagname)
            if (testJustAttTitle) {
                tagname = testJustAttTitle[1]
                attTofind.title = testJustAttTitle[4]
                attTofind.value = undefined
            }

        }

        return this.children.find(ch => {
            return (ch.tagTitle == tagname && (!attTofind.title || attTofind.title && ch.hasTheSameAttributeAndValue(attTofind)))
        })
    }
    /**getChildByTagName */
    __(tagname: string) {
        return this.getChildByTagName(tagname)!
    }
    /**getChildByTagName and Add If note exists */
    __add(tagname: string) {
        return this.getChildByTagName(tagname)! || this.addChildIfNotExists(new MeiTagInstance({
            ...MeiTag.querySelectorToTagAndAttributes(tagname)
        }).setParent(this))
    }

    static querySelectorToTagAndAttributes(selector: string): TMeiTagFactoryArgs {
        const [, tagTitle, rest] = /^([^[]+)(.*)$/.exec(selector) || []
        const attributes = [...rest.matchAll(/\[([^\]=]+)=([^\]]+)\]/g)].map(m => ({ title: m[1], value: m[2] }));
        return { tagTitle, attributes }

    }

    setTextContent(str?: string) {
        this.textContent = str || ''
    }
    pushChild(args: TMeiTagFactoryArgs | MeiTag, index?: number) {
        const toPush = args instanceof MeiTag ? args : MeiTag.makeTagsTree(args, this)
        if (index == undefined) this.children.push(toPush)
        else this.children.splice(index, 0, toPush)
        if (args instanceof MeiTag) args.setParent(this)

    }

    pushChildren(els: (TMeiTagFactoryArgs | MeiTag)[]) {
        for (const el of els) this.pushChild(el)
    }
    removeChildByIndex(idx: number) { this.children.splice(idx, 1) }


    removeEmptyChildren() {
        const indexesToRemove: number[] = []
        this.children.forEach((ch, index) => {

            const doesntHaveChildren = ch.children.length == 0
            const doesntHaveTextContent = ch.textContent == ''
            const doestHaveAttributes = ch.attributes.filter(at => at.value).length == this.attributes.length;
            const inNotSelfClosing = !(ch.selfClosing == true)
            if (doesntHaveChildren && doesntHaveTextContent && doestHaveAttributes && inNotSelfClosing) indexesToRemove.push(index)
            else ch.removeEmptyChildren()
        })
        this.children = this.children.filter((ch, index) => !indexesToRemove.includes(index));
    }

    remove() {
        this.parent?.children.splice(this.parent.children.indexOf(this), 1);
    }
}


export class MeiTagInstance extends MeiTag {
    tagTitle: string;
    constructor(args: TMeiTagFactoryArgs) {
        super();
        this.id = args.id
        this.tagTitle = args.tagTitle
        this.textContent = args.textContent || ''
        this.selfClosing = args.selfClosing
        args.attributes?.forEach(att => this.setAttribute(new MeiAttribute(att.title, att.value)))
        this.children = args.children?.map(ch => ch instanceof MeiTag ? ch : new MeiTagInstance(ch)) || []
    }
    setAttributes(): void { return; }
    updateChildren(): MeiTag {
        return this;
    }





}


export class MeiText extends MeiTag {
    tagTitle = '';
    set textContent(tc: string ) {
        this._textContent = tc || ''
    }
    get textContent(){return this._textContent}
    constructor(private  _textContent: string  ,public indexAmongSiblings: number) {
        super()
    }
    updateChildren(options?: { keepEmptyNotes?: boolean; }): MeiTag {
        return this;
    }
    toJsonXmlElement(options?: { keepEmptyNotes: boolean; }): MeiJsonElem {
        return new MeiJsonElem({
            attributes: [], children: [], tagTitle: '', textContent: this._textContent, indexAmongSiblings: this.indexAmongSiblings,
            
        })
    }


}